module.exports = __webpack_public_path__ + "static/media/robot.27412fc0.svg";